<template>
  <div
    v-if="adv"
    style="position:relative">
    <div
      v-if="externalConnection()"
      class="is-padding-bottom-small">
      <span class="has-text-weight-bold">
        Export {{ externalConnectionErreur[0].connection_type }}
      </span>
      - Dernière Synchronisation le {{ getExternalConnectionDate(externalConnectionErreur[0].created_on) }} -
      <span class="has-text-weight-bold">
        Statut :
        <span
          v-if="externalConnectionErreur[0].is_error"
          class="has-text-danger">
          Invalide (
          <span
            @click="goToExternalConnectionHistory"
            class="has-cursor-pointer is-underline">
            Historique
          </span>
          )
        </span>
        <span
          v-else
          class="has-text-success">
          Valide (
          <span
            @click="goToExternalConnectionHistory"
            class="has-cursor-pointer is-underline">
            Historique
          </span>
          )
        </span>
      </span>
    </div>
    <div
      v-if="sageConnector()"
      class="is-padding-bottom-small">
      <span class="has-text-weight-bold">
        Export SAGE
      </span>
      - Dernière Synchronisation le {{ getExternalConnectionDate(sageConnectorError[0].created_on) }} -
      <span class="has-text-weight-bold">
        Statut :
        <span
          v-if="sageConnectorError[0].is_error"
          class="has-text-danger">
          Invalide (
          <span
            @click="goToExternalConnectionHistory"
            class="has-cursor-pointer is-underline">
            Historique
          </span>
          )
        </span>
        <span
          v-else
          class="has-text-success">
          Valide (
          <span
            @click="goToExternalConnectionHistory"
            class="has-cursor-pointer is-underline">
            Historique
          </span>
          )
        </span>
      </span>
    </div>
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <div class="vadStepschronological is-margin-bottom-xsmall">
      <div class="vadStepschronological-item is-valid">
        <div class="vadStepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="vadStepschronological-item-info">
          <span class="is-uppercase">Passage en pré-reservation</span>
          <div class="vadStepschronological-item-info-sub">
            <span class="is-uppercase">Le {{ adv.pre_reservation_date | dtFormat('DD/MM/YYYY') }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="adv.status != 'pre_reserved'"
        class="vadStepschronological-item"
        :class="{'is-valid' : adv.signature_date}">
        <div class="vadStepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="vadStepschronological-item-info">
          <span class="is-uppercase">Signature contrat de réservation</span>
          <span
            v-if="!adv.signature_date"
            class="vadStepschronological-item-info-sub">
            En attente de signature
          </span>
          <span
            v-else
            class="vadStepschronological-item-info-sub">
            <span class="is-uppercase">Le {{ adv.signature_date | dtFormat('DD/MM/YYYY') }}</span>
          </span>
        </div>
      </div>
      <div
        v-else
        class="vadStepschronological-item">
        <div class="vadStepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="vadStepschronological-item-info">
          <span class="is-uppercase">Date de signature prévue</span>
          <span
            class="vadStepschronological-item-info-sub">
            <date-picker
              :text="'En attente d\'une date'"
              id="startDatePicker"
              :model="adv.previous_sign_date"
              :style-version="4"
              :clearable="false"
              @input="val => updatePreviousDate(val)"></date-picker>
          </span>
        </div>
      </div>
      <div
        class="vadStepschronological-item"
        :class="{'is-valid' : financementCheck && (adv.status === 'reserved' || adv.status === 'sold')}">
        <div class="vadStepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="vadStepschronological-item-info">
          <span class="is-uppercase">Financement validé</span>
          <router-link
            v-if="!financementCheck && (adv.status === 'reserved' || adv.status === 'sold')"
            :to="{name: 'Financement', params: {id: advPk}}"
            class="vadStepschronological-item-info-sub">
            Renseigner
          </router-link>
          <router-link
            v-else-if="adv.status === 'reserved' || adv.status === 'sold'"
            :to="{name: 'Financement', params: {id: advPk}}"
            class="vadStepschronological-item-info-sub">
            Consulter
          </router-link>
          <span
            v-else
            class="vadStepschronological-item-info-sub">
            En attente de signature
          </span>
        </div>
      </div>
      <div
        class="vadStepschronological-item"
        :class="{'is-valid' : adv.sale_date}">
        <div class="vadStepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="vadStepschronological-item-info">
          <span class="is-uppercase">Signature acte</span>

          <span
            v-if="adv.sale_date"
            class="vadStepschronological-item-info-sub">
            <span class="is-uppercase">Le {{ adv.sale_date | dtFormat('DD/MM/YYYY') }}</span>
          </span>
          <router-link
            v-else-if="isAdmin && isPromoteur && (adv.status === 'reserved' || adv.status === 'sold')"
            :to="{name: 'Notaire', params: {id: advPk}, query: {acte: true}}"
            class="vadStepschronological-item-info-sub">
            Renseigner
          </router-link>
          <router-link
            v-else-if="(adv.status === 'reserved' || adv.status === 'sold')"
            :to="{name: 'Notaire', params: {id: advPk}, query: {acte: true}}"
            class="vadStepschronological-item-info-sub">
            Consulter
          </router-link>
          <span
            v-else
            class="vadStepschronological-item-info-sub">
            En attente de signature
          </span>
        </div>
      </div>
    </div>
    <div class="columns is-gapless is-multiline is-margin-neg-left-xxsmall is-margin-neg-right-xxsmall">
      <div class="column is-12 is-7-widescreen is-7-fullhd is-self-flex-start is-padding-left-xxsmall is-padding-right-xxsmall is-padding-top-xxsmall">
        <div class="is-border has-background-white is-height-full">
          <div class="has-background-light">
            <!-- Première ligne : Destination / Dispositif / Objet de l'achat -->
            <div class="columns is-gapless is-vcentered is-multiline is-minH50p is-padding-top-xxsmall is-padding-bottom-xxsmall">
              <!-- Destination -->
              <div
                class="column is-narrow is-padding-left is-uppercase ">
                <div
                  class="columns is-vcentered"
                  style="height: 40px">
                  <div
                    class="column is-paddingless is-narrow is-margin-right-small">
                    <label
                      for="destination"
                      class="has-text-grey is-size-6 is-uppercase">
                      Destination :
                    </label>
                  </div>
                  <div
                    class="column is-paddingless">
                    <div class="field center-vertically">
                      <div class="select is-transparent is-small is-paddingless-left">
                        <select
                          id="destination"
                          class="has-text-weight-medium"
                          @change="$store.commit('modifyCurrentAdv', { key: 'destination', value: adv.destination })"
                          v-model="adv.destination">
                          <option :value="null">
                            Sélectionner
                          </option>
                          <option
                            v-for="a in advDestinationsList"
                            :key="a.value"
                            :value="a.value">
                            {{ a.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Dispositif -->
              <div
                v-if="(adv.destination === 'invest' || adv.destination === 'main_residence') && !isParking"
                class="column is-narrow is-padding-left is-uppercase ">
                <div
                  class="columns is-vcentered"
                  style="height: 40px">
                  <div
                    class="column is-paddingless is-narrow is-margin-right-small">
                    <label
                      for="dispositif"
                      class="has-text-grey is-size-6 is-uppercase">
                      Dispositif :
                    </label>
                  </div>
                  <div
                    class="column is-paddingless">
                    <div class="field center-vertically">
                      <div class="select is-transparent is-small is-paddingless-left">
                        <select
                          id="dispositif"
                          class="has-text-weight-medium"
                          @change="$store.commit('modifyCurrentAdv', { key: 'tax_dispositif', value: adv.tax_dispositif })"
                          v-model="adv.tax_dispositif">
                          <option :value="null">
                            Sélectionner
                          </option>
                          <template>
                            <option
                              v-for="a in dispositifs"
                              :key="a.value"
                              :value="a.value">
                              {{ a.label }}
                            </option>
                          </template>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Objectif de l'achat -->
              <div
                v-if="adv.destination && adv.destination === 'invest'"
                class="column is-narrow is-padding-left is-uppercase">
                <div
                  style="height: 40px"
                  class="columns is-vcentered">
                  <div class="column is-paddingless is-narrow is-margin-right-small">
                    <label
                      for="purchase_purpose"
                      class="has-text-grey is-size-6 is-uppercase">
                      Objectif de l'achat :
                    </label>
                  </div>
                  <div
                    class="column is-paddingless"
                    v-if="isAdmin && isPromoteur">
                    <div class="field">
                      <div class="select is-transparent is-small is-paddingless-left">
                        <select
                          id="purchase_purpose"
                          @change="$store.commit('modifyCurrentAdv', { key: 'purchase_purpose', value: adv.purchase_purpose })"
                          v-model="adv.purchase_purpose"
                          class="has-text-weight-medium">
                          <option :value="null">
                            Sélectionner
                          </option>
                          <option
                            v-for="a in PurposePurchaseValueList"
                            :key="a.value"
                            :value="a.value">
                            {{ a.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Deuxième ligne : Mandat de gestion -->
            <div
              v-if="adv.destination && adv.destination === 'invest'"
              class="columns is-gapless is-vcentered is-multiline is-minH50p is-padding-bottom-xxsmall">
              <!-- Mandat de gestion -->
              <div
                class="column is-narrow is-padding-left is-uppercase">
                <div
                  style="height: 40px"
                  class="columns is-vcentered">
                  <div class="column is-paddingless is-narrow is-margin-right-small">
                    <label
                      for="mandat_de_gestion"
                      class="has-text-grey is-size-6 is-uppercase">
                      Mandat de gestion :
                    </label>
                  </div>
                  <div
                    class="column is-paddingless"
                    v-if="isAdmin && isPromoteur">
                    <div class="field">
                      <div class="select is-transparent is-small is-paddingless-left">
                        <select
                          id="mandat_de_gestion"
                          v-model="adv.mandat_de_gestion"
                          class="has-text-weight-medium">
                          <option :value="null">
                            NC
                          </option>
                          <option :value="true">
                            Oui
                          </option>
                          <option :value="false">
                            Non
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <b v-if="adv.mandat_de_gestion">Oui</b>
                    <b v-else-if="adv.mandat_de_gestion === false">Non</b>
                    <b v-else-if="adv.mandat_de_gestion === null">NC</b>
                  </div>
                </div>
              </div>

              <!-- Document mandat de gestion -->
              <div
                class="column is-narrow is-padding-left is-uppercase"
                v-if="adv.mandat_de_gestion === true && !loadingDoc && isAdmin && isPromoteur">
                <div class="is-size-6">
                  <div v-if="adv.mandat_de_gestion_file !== null">
                    <router-link
                      tag="a"
                      :to="{name: 'AdvDocuments'}"
                      class="is-underline is-italic">
                      Mandat de gestion
                    </router-link>
                  </div>
                  <div v-else>
                    <label
                      class="button is-white is-rounded is-size-6"
                      style="text-transform: none; color: black; border-color: #e8e8e8;">
                      <input
                        class="file-input"
                        type="file"
                        accept="image/*, .pdf"
                        name="file"
                        @change="uploadDocument($event.target.files)" />
                      Télécharger mandat de gestion
                    </label>
                  </div>
                </div>
              </div>
              <div
                class="column is-narrow is-paddingless-top is-paddingless-right is-self-centered"
                v-else-if="loadingDoc">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
            </div>
          </div>
          <div class="columns is-gapless is-mobile is-minH50p is-border-top is-marginless">
            <div class="column is-padding-left is-padding-right is-self-centered">
              <span class="is-uppercase title is-6">Vendeur(s) / Mandataire(s)</span>
            </div>
            <div
              v-if="sale && !userIsAnonymous && sale.users_in_sale && sale.users_in_sale.length < 3 && isAdmin && isPromoteur"
              class="actionsOnRow actionsOnRow--vertical">
              <div class="is-minH100">
                <router-link
                  tag="button"
                  :to="{name: 'Commercialisation', params: {id: advPk}}"
                  class="tooltip is-tooltip-left"
                  data-tooltip="Ajouter un vendeur ou mandataire">
                  <span class="icon"><i class="fas fa-user-plus"></i></span>
                </router-link>
              </div>
            </div>
          </div>
          <template v-if="sale && sale.users_in_sale && sale.users_in_sale.length">
            <template v-for="(userInSale, i) in sale.users_in_sale">
              <div
                :key="userInSale.user.pk"
                class="has-background-light has-text-primary is-multiline is-padding is-border-top">
                <div class="columns is-gapless is-vcentered">
                  <div class="column is-narrow is-margin-right-xsmall">
                    <avatar
                      :item="userInSale.user"
                      :i="i"
                      :classes="avatarColor"></avatar>
                  </div>
                  <div class="column">
                    <b>{{ userInSale.user.last_name }} {{ userInSale.user.first_name }}</b>
                    <br>
                    <span v-if="userInSale.user.account">Société {{ userInSale.user.account.name }}</span>

                    <span
                      class=""
                      v-if="(isAdmin && userInSale.user.account.pk === currentUser.account.pk) || (isAdmin && isPromoteur) || (currentUser.pk === userInSale.user.pk)">
                      <span class="is-size-6">
                        (COMM : {{ userInSale.remuneration }}% :
                        <span> {{ Number(userInSale.total_ht).toFixed(2) }} € HT
                          <router-link
                            v-if="isAdmin && isPromoteur"
                            :to="{name: 'Commercialisation', params: {id: advPk}}"
                            class="is-underline">
                            - Modifier
                          </router-link>
                          )
                        </span>
                      </span>
                    </span>
                    <div v-if="userInSale.bonus_ht && ((isAdmin && userInSale.user.account.pk === currentUser.account.pk) || (isAdmin && isPromoteur) || (currentUser.pk === userInSale.user.pk))">
                      <span class="is-size-6 is-uppercase">Bonus : <span
                        class="is-size-6">{{ userInSale.bonus_ht }} €</span></span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else-if="seller">
            <div class="has-background-light has-text-primary is-multiline is-padding is-border-top">
              <div class="columns is-gapless is-vcentered">
                <div class="column is-narrow is-margin-right-xsmall">
                  <avatar
                    :item="seller"
                    :classes="avatarColor"></avatar>
                </div>
                <div class="column">
                  <b>{{ seller.last_name }} {{ seller.first_name }}</b>
                  <br>
                  <span v-if="seller.account">Société {{ seller.account.name }}</span>

                  <span class="">
                    <span
                      class="is-size-6"
                      v-if="adv && adv.seller_remuneration">
                      (COMM : {{ adv.seller_remuneration }}%)
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </template>
          <div class="columns is-gapless is-mobile has-background-white is-minH50p is-border-top is-border-bottom is-marginless">
            <div class="column is-padding-left is-padding-right is-self-centered">
              <span class="is-uppercase title is-6">Réservataire(s) / Acquéreur(s)</span>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger w100">
                  <button
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    :data-tooltip="!canAdd ?'Vous avez atteint la limite maximum de 4 acquéreurs' : ''"
                    :class="{'tooltip is-tooltip-left is-tooltip-primary': !canAdd}"
                    class="">
                    <span class="icon"><i class="far fa-ellipsis-v"></i></span>
                  </button>
                </div>
                <div
                  role="menu"
                  class="dropdown-menu"
                  v-if="canAdd">
                  <div class="dropdown-content has-text-left">
                    <a
                      @click="openBuyerSelection"
                      class="dropdown-item">
                      <span class="icon"><i class="fas fa-user"></i></span> Sélectionner un co-acquéreur
                    </a>
                    <a
                      @click="openNewContactQuickview({}, null, null, null, true)"
                      class="dropdown-item">
                      <span class="icon"><i class="fas fa-user-plus"></i></span> Créer un co-acquéreur
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-for="(buyer, index) in buyers">
            <membre-adv
              class="is-border-bottom"
              :key="index"
              :is-grey="true"
              :index="index"
              :membre="buyer"
              :is-co-acquereur="index > 0"
              @updateContact="openModalContactInfo"
              @updateContactCard="updateContactCard"
              @createAndReplaceBuyers="openReplaceModalContactInfo"
              @deleteCobuyer="deleteBuyer"
              :is-promoteur="false"
              :modal-promoteur="false"
              :can-edit="true"
              :from-resa="true"></membre-adv>
          </template>
          <!-- Mention particulière -->
          <!-- <div
            v-if="isAdmin && isPromoteur"
            class="has-background-white">
            <div class="row-width-actions-bar columns is-gapless is-marginless">
              <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
                <span class="is-uppercase title is-6">Mention particulière</span>
              </div>
              <div class="column is-narrow is-border-left">
              </div>
            </div>
            <template v-if="openComment">
              <div
                v-if="!openCommentWysi && mention_comment"
                @click="openWysiwyg"
                class="vadDiscussion is-border-top"
                style="cursor: pointer;">
                <div
                  class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                  <div
                    class="content"
                    v-if="isAdmin && mention_comment"
                    v-html="mention_comment"></div>
                  <div class="actionsOnRow actionsOnRow--vertical">
                    <div class="">
                      <button
                        @click="openWysiwyg"
                        class="is-min-height-full">
                        <span class="icon is-small"><i class="fal fa-edit"></i></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="is-border-top columns is-gapless">
                <div class="column">
                  <wysiwyg-editor
                    :light="true"
                    :tooltip-top="true"
                    :model="mention_comment"
                    @change="val => mention_comment = val"
                    class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                  </wysiwyg-editor>
                </div>
                <div class="actionsOnRow actionsOnRow--vertical">
                  <div>
                    <button
                      @click="patchMentionComment()"
                      type="button"
                      class="button"
                      :class="[(baseMentionComment !== mention_comment) ? 'is-success' : 'is-info']"
                      :disabled="(baseMentionComment === mention_comment)">
                      <span class="icon is-small">
                        <i
                          v-if="loadMentionComment"
                          class="fas fa-spinner fa-spin"></i>
                        <i
                          v-else
                          class="fal fa-save"></i>
                      </span>
                    </button>
                  </div>
                  <div class="">
                    <button
                      :disabled="!baseMentionComment"
                      type="button"
                      :class="{'actionsOnRow-btn--hoverIsDanger': mention_comment}"
                      @click="mention_comment ? openCommentWysi = false : null; mention_comment = baseMentionComment">
                      <span class="icon is-small"><i class="fal fa-times"></i></span>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div> -->
          <!-- Commentaire -->
          <div
            v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
            class="has-background-white">
            <div class="row-width-actions-bar columns is-gapless is-marginless">
              <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
                <span class="is-uppercase title is-6">Commentaire</span>
              </div>
              <div class="column is-narrow is-border-left">
              </div>
            </div>
            <template v-if="openComment">
              <div
                v-if="!openCommentWysi && comment"
                @click="openWysiwyg"
                class="vadDiscussion is-border-top"
                style="cursor: pointer;">
                <div
                  class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                  <div
                    class="content"
                    v-if="(isAdmin || currentUser.active_all_contact) && comment"
                    v-html="comment"></div>
                  <div class="actionsOnRow actionsOnRow--vertical">
                    <div class="">
                      <button
                        @click="openWysiwyg"
                        class="is-min-height-full">
                        <span class="icon is-small"><i class="fal fa-edit"></i></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="is-border-top columns is-gapless">
                <div class="column">
                  <wysiwyg-editor
                    :light="true"
                    :tooltip-top="true"
                    :model="comment"
                    @change="val => comment = val"
                    class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                  </wysiwyg-editor>
                </div>
                <div class="actionsOnRow actionsOnRow--vertical">
                  <div>
                    <button
                      @click="patchComment()"
                      type="button"
                      class="button"
                      :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                      :disabled="(baseComment === comment)">
                      <span class="icon is-small">
                        <i
                          v-if="loadComment"
                          class="fas fa-spinner fa-spin"></i>
                        <i
                          v-else
                          class="fal fa-save"></i>
                      </span>
                    </button>
                  </div>
                  <div class="">
                    <button
                      :disabled="!baseComment"
                      type="button"
                      :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                      @click="comment ? openCommentWysi = false : null; comment = baseComment">
                      <span class="icon is-small"><i class="fal fa-times"></i></span>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="column is-12 is-5-widescreen is-5-fullhd is-order-first-desktop is-order-2-widescreen is-padding-left-xxsmall is-padding-right-xxsmall is-padding-top-xxsmall">
        <div class="has-background-white is-border">
          <div
            v-if="adv.pack"
            class="has-background-light is-padding">
            <span class="is-uppercase">Prix pack : </span><span
              class="has-text-weight-medium">{{ adv.pack.name }}</span>
            <br>
            <b
              v-if="adv.pack.description"
              class="is-size-6"
              v-html="adv.pack.description"></b>
          </div>

          <div
            :class="{'is-border-top' : adv.pack}"
            class="has-background-light columns is-vcentered is-marginless is-gapless is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p">
            <div class="column is-padding-left is-3">
              <r-label
                :is-required="false"
                :label="'Prix de vente lot HT'"></r-label>
            </div>
            <div class="column is-padding-left is-3">
              <r-label
                :is-required="false"
                :label="'TVA'"></r-label>
            </div>
            <div class="column is-padding-left">
              <r-label
                :is-required="false"
                :label="'Prix de vente TTC'"></r-label>
            </div>
          </div>
          <div
            v-if="!updateMode"
            class="has-background-reserved is-border-top columns is-vcentered is-marginless is-gapless is-minH50p has-text-white">
            <div class="column is-padding-left is-3">
              <b class="is-size-4"><span v-if="adv.sale_price_ht">{{ adv.sale_price_ht | prettyPrice }}</span><span
                v-else>{{ adv.sale_price_ht | prettyPrice }}</span> € HT</b>
            </div>
            <div class="column is-padding-left is-3">
              <b class="is-size-4">{{ adv.tva.toFixed(2) }} % </b><span class="is-size-5">({{ adv.sale_price_ttc - adv.sale_price_ht | prettyPrice }}€)</span>
            </div>
            <div class="column is-padding-left">
              <b class="is-size-4">
                <span v-if="adv.sale_price_ttc">{{ adv.sale_price_ttc | prettyPrice }}</span>
                <span v-else>{{ adv.sale_price_ttc | prettyPrice }}</span> € TTC
              </b>
            </div>
            <div
              class="column is-narrow is-self-stretched"
              v-if="isAdmin && isPromoteur">
              <button
                @click="updateMode = true"
                class="button is-small is-white is-transform-none is-padding-left-small is-padding-right-small is-height-full is-radiusless">
                <span class="">Modifier</span>
              </button>
            </div>
          </div>
          <div
            v-else
            class="has-background-white-bis-darken-1 is-border-top">
            <div class="columns is-vcentered is-gapless is-minH50p is-marginless-bottom is-margin-right is-margin-top-xsmall">
              <div class="column is-padding-left">
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input
                      id="sale_price_ht"
                      name="sale_price_ht"
                      @input="val => adv.sale_price_ht = val"
                      :model="adv.sale_price_ht"
                      class=""
                      v-validate="'decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      :number="true"
                      :three-space="true"
                      input-type="number"
                      data-vv-as="">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-static is-border">
                      <span class="icon is-small"><i class="fas fa-euro-sign"></i></span>
                      <span>HT</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-padding-left">
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input
                      id="tva"
                      name="tva"
                      @input="val => updateTva(val)"
                      :model="adv.tva"
                      v-validate="'decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      :number="true"
                      input-type="number"
                      data-vv-as="">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-static is-border">
                      <span class="icon is-small"><i class="fas fa-percentage"></i></span>
                      <span>TVA</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-padding-left">
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <v-input
                      id="sale_price_ttc"
                      name="sale_price_ttc"
                      @input="val => adv.sale_price_ttc = val"
                      :model="adv.sale_price_ttc"
                      class=""
                      v-validate="'decimal:2'"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      :number="true"
                      :three-space="true"
                      input-type="number"
                      data-vv-as="">
                    </v-input>
                  </div>
                  <div class="control">
                    <a class="button is-static is-border">
                      <span class="icon is-small"><i class="fas fa-euro-sign"></i></span>
                      <span>TTC</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="is-12 is-paddingless is-margin-right is-margin-left is-margin-top-xsmall is-margin-bottom-xsmall">
              <r-label
                label="Nature remise"
                class="is-marginless"
                :is-required="false"
                :value="adv.nature_discount">
              </r-label>
              <div class="columns is-vcentered is-gapless is-minH50p">
                <div class="column select is-fullwidth">
                  <select
                    v-model="adv.nature_discount"
                    id="reason">
                    <option :value="null">
                      Sélectionnez le motif de la remise
                    </option>
                    <option
                      v-for="c in priceChangeReasonChoices"
                      :value="c.value"
                      :key="c.value"
                      :id="c.value">
                      {{ c.label }}
                    </option>
                  </select>
                </div>
                <div class="column is-narrow is-padding-left-xsmall">
                  <button
                    @click="patchSalePrice"
                    class="button is-success is-transform-none is-radiusless"
                    :disabled="loadinSalePrice">
                    <span class="icon is-small is-margin-left-xsmall is-margin-right-xsmall">
                      <i
                        v-if="loadinSalePrice"
                        class="fas fa-spinner fa-spin"></i>
                      <i
                        v-else
                        class="fas fa-save"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="is-border-top has-background-light is-padding-left is-padding-top-small is-padding-bottom-small"
            v-if="adv.sale_price_ttc !== lotPrice">
            <span class="is-uppercase has-text-weight-medium">Prix initial : {{ lotPrice|prettyPrice }} € TTC </span>
            <span
              v-if="adv.nature_discount"
              class="is-italic is-size-5 is-margin-left-xsmall"> ({{ natureDiscountLabel }}) </span>
          </div>
          <div
            v-if="!isParking"
            class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
            <div
              class="has-background-white column is-padding-top-xsmall is-padding-bottom">
              <div class="is-padding-left">
                <b class="is-size-6">Dont prix {{ adv.parkings.length > 1 ? 'des stationnements' : 'du stationnement' }}</b>
              </div>
              <div
                class="columns is-padding-left is-gapless is-multiline is-padding-top-small"
                v-if="adv.parkings.length === 0">
                <span class="is-size-6">Aucun parking séléctionné</span>
              </div>
              <template
                v-else
                v-for="(parking, idx) in adv.parkings">
                <div
                  :key="idx"
                  class="columns is-gapless is-multiline is-padding-top-small">
                  <div class="column is-12 is-padding-left">
                    <b class="is-size-6">{{ parking.nature | lotTypeLabel }} :</b>&nbsp;
                    <span
                      class="is-size-6"
                      v-for="(type, i ) in parking.parking_type"
                      :key="'type' + i">{{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}</span>&nbsp;
                    <span
                      class="is-size-6"
                      v-if="parking.info">({{ parking.info }})</span>&nbsp;
                    <span
                      class="is-size-6"
                      v-for="(sale_mode, i ) in parking.sales_mode"
                      :key="'sale_mode' + i">{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}</span>
                  </div>
                  <div class="column is-3 is-4-widescreen is-padding-left">
                    <b class="is-size-6">{{ parking.sale_price_ht.toFixed(2) }} € HT</b>
                  </div>
                  <div class="column is-3 is-4-widescreen is-padding-left">
                    <b
                      v-if="parking.sale_price_ttc > 0 && parking.sale_price_ht > 0"
                      class="is-size-6">TVA : {{ Math.round((((parking.sale_price_ttc - parking.sale_price_ht) / parking.sale_price_ht) *100 ) * 100) / 100 }} % ({{ parking.sale_price_ttc - parking.sale_price_ht| prettyPrice }} €)</b>
                    <b
                      v-else
                      class="is-size-6">TVA : 0 % (0 €)</b>
                  </div>
                  <div class="column is-3 is-4-widescreen is-padding-left">
                    <b class="is-size-6">{{ parking.sale_price_ttc.toFixed(2) }} € TTC</b>
                  </div>
                </div>
              </template>
            </div>
            <div
              v-if="!lotIsDeleted && !programIsDeleted && (isAdmin && isPromoteur)"
              class="actionsOnRow actionsOnRow--vertical">
              <div class="is-minH100">
                <button
                  class="tooltip is-tooltip-left"
                  data-tooltip="Modifier les parkings sélectionnés"
                  @click="openModalLotInfo()">
                  <span class="icon"><i class="fal fa-file-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
          <adv-lot-compact
            :lot="lot"
            :program="program"
            v-if="lot && program"
            :display-button="!lotIsDeleted && !programIsDeleted && (isAdmin && isPromoteur)" />
        </div>
      </div>

      <div
        v-if="canEdit && pendingSubmit"
        class="column is-12 is-7-widescreen is-7-fullhd is-order-3-desktop formActionsSticky is-bottom is-zindex-2 is-padding-left-xxsmall is-padding-right-xxsmall">
        <submit-sticky-buttons
          :cancel="appelCancel"
          @submit="updateAdv"
          button-id="advInfos"
          :submit-text="'Enregistrer'"
          :loading="submitLoading"></submit-sticky-buttons>
      </div>
      <div
        v-if="isAdmin && isPromoteur"
        class="column is-12 is-7-widescreen is-7-fullhd is-order-3-desktop is-padding-left-xxsmall is-padding-right-xxsmall">
        <event-tracker-list :field="'reservation'"></event-tracker-list>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues, Quickview, Adv, Upload } from '@/mixins'
import { mapState } from 'vuex'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { PRICE_CHANGE_REASON_CHOICES } from '@/mixins/DefaultValues'

export default {
  name: 'AdvInfos',
  components: {
    MembreAdv: () => import('../MembreAdv'),
    AdvLotCompact: () => import('../AdvLotCompact')
  },
  mixins: [DefaultValues, Quickview, Adv, Upload],
  data () {
    return {
      validDocument: null,
      updateMode: false,
      loadingDoc: false,
      shares: [],
      files: [],
      loadinSalePrice: false,
      externalConnectionErreur: [],
      duplicateContact: false,
      duplicateDenunciation: false,
      advTaxDispo: [],
      dispositifs_list: [],
      invest: false,
      main_residence: false,
      sageConnectorError: []
    }
  },
  computed: {
    ...mapState(['quickview', 'modal']),
    /**
      * loans
      * @returns {object}
      */
    loans () {
      return this.sale.funding_data.loans
    },
    /**
      * financement is complete
      * @returns {boolean}
      */
    financementCheck () {
      if (!isEmpty(this.sale) && this.sale.funding_data) {
        if (!this.sale.funding_data.use_loan) {
          return true
        } else {
          let loans = []
          this.sale.funding_data.loans.forEach(loan => {
            if (loan.bank_name !== null && loan.bank_name !== '' &&
                loan.edition_de_l_offre !== null && loan.edition_de_l_offre !== '' &&
                loan.signature_de_l_offre !== null && loan.signature_de_l_offre !== '') loans.push(loan)
          })
          if (this.sale.funding_data.loans && this.sale.funding_data.loans.length && loans.length === this.sale.funding_data.loans.length) {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
    },
    /**
      * avatar color by status
      * @returns {string}
      */
    avatarColor () {
      const COLORS = {
        'canceled': 'has-background-draft',
        'reserved': 'has-background-reserved',
        'optioned': 'has-background-optionne'
      }
      return COLORS[this.status]
    },
    dispositifs () {
      let dispositifs
      const creationDate = new Date(this.adv.created_on)
      const referenceYear = 2025
      const creationYear = creationDate.getFullYear()
      const includeOldAdv = creationYear < referenceYear
      if (this.adv.destination === 'invest') {
        if (this.isAdmin && this.isPromoteur) {
          // dispositifs = this.typesTaxList.filter((x) => x.show.includes('adv'))
          dispositifs = this.typesTaxList.filter((x) => {
            return x.show.includes('adv') || (includeOldAdv && x.show.includes('oldAdv'))
          })
        } else {
          let lotDispositifs = this.adv.lot.tax_dispositifs.filter(t => t !== 'prix_maitrise')
          dispositifs = this.typesTaxList.filter(dispositif => lotDispositifs.includes(dispositif.value))
        }
      }
      if (this.adv.destination === 'main_residence') {
        if (this.isAdmin && this.isPromoteur) {
          dispositifs = this.dispositifsChoicesRpList
        } else {
          let lotDispositifs = this.adv.lot.tax_dispositifs.filter(t => t === 'prix_maitrise')
          dispositifs = this.dispositifsChoicesRpList.filter(dispositif => lotDispositifs.includes(dispositif.value))
        }
      }
      return dispositifs
    },
    isExternalConnection () {
      if (this.adv.promoteur.external_connection && this.adv.promoteur.external_connection.length) {
        return true
      } else {
        return false
      }
    },
    isExternalConnectioSage () {
      if (this.adv.promoteur.sageConnector && this.adv.promoteur.sageConnector.length) {
        return true
      } else {
        return false
      }
    },
    priceChangeReasonChoices () {
      return Object.values(PRICE_CHANGE_REASON_CHOICES)
    },
    natureDiscountLabel () {
      return this.priceChangeReasonChoices.find(x => x.value === this.adv.nature_discount).label
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results) {
        if (mode === 'CONTACT_SELECTION') {
          if (results.entities.length) {
            results.entities.forEach(x => {
              if (params.note === 'replaceBuyer') {
                this.createAndReplaceBuyers(x, params.index)
                this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
              } else {
                this.addContact(x)
              }
            })
          } else {
            this.$toasted.global.danger('Veuillez sélectionner un utilisateur')
          }
        } else if (mode === 'CONTACT_CREATE' && results) {
          let check = 'CONTACT_CREATE'
          if (params.replaceBuyer === true && params.index != null) {
            this.createAndReplaceBuyers(results.contact, params.index)
            this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
          } else {
            this.verifBeforeCreateContact(results.contact, check)
          }
        } else if (mode === 'CONTACT_UPDATE' && results && params && params.fromBuyerEdit) {
          this.updateContactCard(results.contact).then(ok => {
            if (ok) {
              this.updateContact(results.contact, params.index)
              this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
            }
          })
        } else if (mode === 'PROMOTEUR_UPDATE' && results) {
          this.$store.commit('modifyCurrentAdv', { key: 'promoteur_data', value: results.promoteur })
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        } else if (mode === 'CONTACT_CHECK_CREATE' && results) {
          this.createContact(results.contact)
        }
      }
    },
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'PARKING_INFO') {
          this.updateParkings(results)
        }
      }
    },
    'adv.mandat_de_gestion' (v) {
      this.$store.commit('modifyCurrentAdv', { key: 'mandat_de_gestion', value: v })
    },
    'adv.destination' (to, old) {
      if (old !== undefined && to !== old) {
        this.adv.tax_dispositif = null
      }
      if (to !== 'invest' || to !== 'main_residence') {
        this.adv.tax_dispositif = null
        this.$store.commit('modifyCurrentAdv', { key: 'tax_dispositif', value: null })
      }
    }
  },
  async created () {
    this.invest = false
    this.main_residence = false
    this.files = new FormData()
    this.initTaxDispo()
    if (this.currentAdv.promoteur.sage_connector) {
      this.sageConnectorError = await this.$api.get(this.$resources.RESERVATION_SAGE_CONNECTOR_HISTORY(this.currentAdv.pk))
      this.sageConnectorError = this.sageConnectorError.data.items
    } else {
      this.externalConnectionErreur = await this.$api.get(this.$resources.RESERVATION_EXTERNAL_CONNECTION_HISTORY(this.currentAdv.pk))
      this.externalConnectionErreur = this.externalConnectionErreur.data.items
    }
  },
  methods: {
    /**
      * add contact
      * @param {object} val - contact
      */
    async addContact (val) {
      let contact = await this.getContact(val.pk)
      this.buyers.push(contact)
      this.$store.commit('modifyCurrentAdv', { key: 'buyers_data', value: this.buyers })
      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
    },
    /**
      * get contact
      * @param {string} id - contact id
      */
    async getContact (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, id)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * tva
      * @param {number} ttc
      * @param {number} ht
      * @returns {number} - tva
      */
    tva (ttc, ht) {
      let calc = ((ttc - ht) / ht) * 100
      return Math.round(calc * 100) / 100
    },
    /**
      * uplaod document
      * @param {array} files
      */
    async uploadDocument (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.files.append('file[]', file, file.name)
        this.validDocument = await this.checkAutorizedFile(file)
      }
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let uploadFiles = this.files
      this.loadingDoc = true
      let config = {
        onUploadProgress: progressEvent => {
          this.progressData = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
        }
      }
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: uploadFiles, config })
        let hostedFiles = res.data.slice()
        hostedFiles = hostedFiles.map(x => {
          return {
            fus_id: x.id,
            cloudinary_id: x.cloudinary_id,
            cloudinary_version: x.cloudinary_version,
            path: x.path,
            filename: 'mandat-de-gestion',
            destination: ['display_in_adv'],
            display: x.display || true
          }
        })
        this.loadingDoc = false
        this.$store.commit('modifyCurrentAdv', { key: 'mandat_de_gestion_file', value: hostedFiles[0] })
        this.$toasted.global.success('Le document à été téléchargé avec succès')
      } catch (e) {
        this.loadingDoc = false
        console.log(e)
        this.$toasted.global.danger('Erreur lors du téléchargement du document !')
      }
    },
    /**
      * create contact
      * @param {object} contact
      */
    async verifBeforeCreateContact (contact, check) {
      this.$store.commit('setQuickviewLoading', true)
      if (this.seller && this.seller.account.pk === this.currentUser.account.pk) {
        contact.user = this.seller.pk
      } else {
        contact.user = this.currentUser.pk
      }
      if (contact.last_name === null || contact.last_name === '') {
        this.$toasted.global.danger('Veuillez renseignez un nom au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (contact.first_name === null || contact.first_name === '') {
        this.$toasted.global.danger('Veuillez renseignez un prénom au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      try {
        this.$store.commit('setQuickviewLoading', false)
        let contactUser = null
        if (this.seller && this.seller.pk) {
          contactUser = this.seller.pk
        } else {
          contactUser = contact.user
        }
        let payload = {
          contact: this.$cleanPayload(contact),
          user: contactUser
        }
        let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
        if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
          this.duplicateDenunciation = data.duplicates.length !== 0 ? this.duplicateDenunciation = true : this.duplicateDenunciation = false
          this.duplicateContact = data.all_pk_contact.length !== 0 ? this.duplicateContact = true : this.duplicateContact = false
          let alert = true
          this.openNewContactQuickview({}, contact, alert, data)
        } else {
          this.createContact(contact)
        }
      } catch (e) {
        this.loading = false
        this.$store.commit('setQuickviewLoading', false)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    async createContact (contact) {
      this.duplicateContact = this.duplicateContact === true ? contact.doublon_contact = true : contact.doublon_contact = false
      this.duplicateDenunciation = this.duplicateDenunciation === true ? contact.doublon_denunciation = true : contact.doublon_denunciation = false

      try {
        let { data } = await this.$api.post(this.$resources.CONTACT, this.$cleanPayload(contact))
        data = data.json_data
        this.buyers.push(data)
        this.$store.commit('modifyCurrentAdv', { key: 'buyers_data', value: this.buyers })
        this.$toasted.global.success('Contact ajouté')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
      * update TVA
      */
    updateTva (val) {
      this.adv.tva = val
    },
    /**
      * patch sale price
      */
    async patchSalePrice () {
      this.calculateMissingValue()
      if (!this.checkCalculeTva()) {
        this.$toasted.error('Il y a une erreur dans votre calcul')
        return
      }
      this.loadinSalePrice = true
      let payload = {
        sale_price_ttc: this.adv.sale_price_ttc,
        tva: this.adv.tva,
        sale_price_ht: this.adv.sale_price_ht,
        nature_discount: this.adv.nature_discount
      }
      try {
        let data = await this.$store.dispatch('patchAdvSalePrice', payload)
        this.initialPrice = data.sale_price_ttc
        this.initialPriceHt = data.sale_price_ht
        this.updateMode = false
        this.$toasted.success('Prix de vente mis a jour')
        this.$emit('getSale')
        this.loadinSalePrice = false
      } catch (e) {
        console.log(e)
        this.$toasted.error('Erreur lors de la mise à jour')
        this.loadinSalePrice = false
      }
    },
    /**
      * open buyer selection
      */
    openBuyerSelection () {
      let buyersPk = this.buyers.map(x => x.pk)
      let params = {
        facets: {
          CONTACT: []
        },
        mode: 'store'
      }
      for (let exclude of buyersPk) {
        params.facets.CONTACT.push([`pk:-${exclude}`])
      }
      this.openContactSelectionQuickview({ params })
    },
    externalConnection () {
      if (this.externalConnectionErreur.length > 0) {
        return true
      }
      return false
    },
    getExternalConnectionDate (date) {
      return moment(date).add(2, 'hours').format('L à HH:mm:ss')
    },
    goToExternalConnectionHistory () {
      this.$router.push({ name: 'ExternalConnectionHistory' })
    },
    initTaxDispo () {
      if (this.taxDispositifsList) {
        for (const dispo of this.taxDispositifsList) {
          if (dispo.show.includes('adv')) {
            this.advTaxDispo.push(dispo)
          }
        }
      }
      return this.advTaxDispo
    },
    updatePreviousDate (val) {
      this.adv.previous_sign_date = val
      this.$store.commit('modifyCurrentAdv', { key: 'previous_sign_date', value: this.adv.previous_sign_date })
    },
    calculateMissingValue () {
      if (this.adv.sale_price_ht == null) {
        const priceHT = this.adv.sale_price_ttc / (1 + (this.adv.tva / 100))
        this.adv.sale_price_ht = Number(priceHT.toFixed(2))
      } else if (this.adv.tva == null || typeof this.adv.tva === 'string') {
        const tva = (this.adv.sale_price_ttc - this.adv.sale_price_ht) / this.adv.sale_price_ht * 100
        this.adv.tva = tva
      } else if (this.adv.sale_price_ttc == null) {
        const priceTTC = this.adv.sale_price_ht * (1 + (this.adv.tva / 100))
        this.adv.sale_price_ttc = Number(priceTTC.toFixed(2))
      }
    },
    checkCalculeTva () {
      const calculatedTTC = this.adv.sale_price_ht * (1 + (this.adv.tva / 100))
      const calculatedHT = this.adv.sale_price_ttc / (1 + (this.adv.tva / 100))
      const calculatedTVA = (this.adv.sale_price_ttc - this.adv.sale_price_ht) / this.adv.sale_price_ht * 100
      return (
        Math.abs(calculatedTTC - this.adv.sale_price_ttc) < 0.01 &&
        Math.abs(calculatedHT - this.adv.sale_price_ht) < 0.01 &&
        Math.abs(calculatedTVA - this.adv.tva) < 0.01
      )
    },
    sageConnector () {
      if (this.sageConnectorError.length > 0) {
        return true
      }
      return false
    },
    async updateContactCard (contact, redirectToSpouse = null) {
      this.submitLoading = true
      try {
        let contactUser = null
        if (contact.user) {
          contactUser = contact.user.pk
        } else {
          contactUser = this.currentUser.pk
        }
        if (contact.spouse === 'null' || contact.spouse === 'undefined') {
          contact.spouse = null
        }
        let payload = {
          contact: this.$cleanPayload(contact),
          user: contactUser
        }
        let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
        if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
          contact.doublon = true
        }
        const programs = contact.programs || []
        contact.programs = Array.from(
          new Set([
            ...programs
              .filter(p => p && p.pk)
              .map(p => p.pk),
            this.adv.program.pk
          ])
        )
        const cleanContact = this.$cleanPayload(contact)
        let putResponse = await this.$api.put(this.$resources.CONTACT, contact.pk, cleanContact)
        let putData = putResponse.data

        // syncChildrenWithSpouse vient de ContactMixin, absent des mixins de cette vue :
        // sans le garde-fou, l'appel plante et affiche un toast d'erreur alors que le PUT a réussi
        if (putData.spouse && putData.spouse.pk && this.syncChildrenWithSpouse) {
          await this.syncChildrenWithSpouse(putData.pk, putData.spouse.pk, false)
          const refreshedContact = await this.$api.getOne(this.$resources.CONTACT, putData.pk)
          putData = refreshedContact.data
        }
        this.submitLoading = false
        this.$toasted.global.success('Contact modifié')
        return true
      } catch (e) {
        console.log(e)
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        return false
      }
    }
  }
}
</script>

<style scoped>
.center-vertically {
  display: flex;
  align-items: center;
}
</style>
